import MakerCheckerClient from './MakerCheckerClient';
import HttpClient from '../../gateway/HttpClient';
import HttpMethod from '../../constant/HttpMethod';
import { MakerCheckerMethods } from '../../constant/MethodNames';
import { CheckerRequest } from '../../domain/maker-checker/MakerCheckerDomains';
import ComponentName from '../../constant/ComponentName';

class NestMakerCheckerClient implements MakerCheckerClient {
  private apiClient: HttpClient;

  constructor(apiClient: HttpClient) {
    this.apiClient = apiClient;
  }

  public approve(id: string, comment: string): Promise<void> {
    return this.apiClient.execute(HttpMethod.POST, MakerCheckerMethods.APPROVE, { id, comment });
  }

  public reject(id: string, comment: string): Promise<void> {
    return this.apiClient.execute(HttpMethod.POST, MakerCheckerMethods.REJECT, { id, comment });
  }

  public findMany(ids: string[]): Promise<CheckerRequest[]> {
    return this.apiClient.execute(HttpMethod.POST, MakerCheckerMethods.FIND_MANY, { ids: ids });
  }

  public findByDocumentId(component: ComponentName, id: string): Promise<CheckerRequest | undefined> {
    return this.apiClient.execute(HttpMethod.GET, MakerCheckerMethods.FIND_BY_DOC_ID, undefined, { component, id });
  }
}

export default NestMakerCheckerClient;
